"use client";

import { useTranslations } from "next-intl";

export default function StoreClosedBanner({ paused = false }: { paused?: boolean }) {
  const t = useTranslations("Checkout"); // Using Checkout.storeClosed for message
  const tClosed = useTranslations("StoreClosed");

  return (
    <div className="w-full bg-red-700 text-black py-3 px-4 flex items-center justify-center text-center border-b border-red-800">
      <div className="flex items-center gap-3 text-lg font-bold tracking-wide uppercase">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
          />
        </svg>
        <span>{paused ? tClosed("pausedBanner") : "SKLEP W TEJ CHWILI JEST ZAMKNIĘTY"}</span>
      </div>
    </div>
  );
}
